import UploadFile from 'components/importImage'
import { useFormik } from 'formik'
import DatePickers from 'global/DatePicker/DatePicker'
import InputNumber from 'global/InputNumber/InputNumber'
import InputText from 'global/InputText/InputText'
import Modal from 'global/Modal/Modal'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { fishValidation } from 'global/Validation/Validation'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { addEditUrls } from 'services/api.enums'
import { addEditDataAPI } from 'services/CRUDServices'

interface BankDeliveryProps {
  open: boolean
  setOpen: any
  refrenceList: any[]
  refreshTable: () => void
  type?: { id: number }
  hub?: any
  extraData?: string
  price?: number
  onCancel?: () => void
  apiUrl?: string
  title?: string
}

function BankDelivery({
  open,
  setOpen,
  refrenceList,
  refreshTable,
  type,
  hub,
  extraData,
  price,
  onCancel,
  apiUrl,
  title = 'مشخصات رسید بانکی',
}: BankDeliveryProps) {
  const { currenthub } = useSelector((state: any) => state.userInfo)
  const [imageID, setIamgeId] = useState('')

  const {
    handleSubmit,
    handleChange,
    values,
    touched,
    errors,
    setFieldValue,
    isSubmitting,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: fishValidation,
    initialValues: {
      receiptNo: '',
      receiptDate: '',
      price: price,
      description: '',
    },
    onSubmit: async () => {
      const endpoint = apiUrl ?? addEditUrls.addFish
      if (!imageID) {
        toast.error('لطفا تصویر را آپلود کنید')
        return
      }
      try {
        const DTO = {
          isActive: true,
          receiptNo: values.receiptNo,
          receiptDate: values.receiptDate,
          price: values?.price,
          receiptPicture: imageID,
          hub: {
            id: hub ?? currenthub?.id,
          },
          type: type,
          description: extraData
            ? values.description + ' / ' + extraData?.toString()
            : values.description,
          refrenceList,
        }
        await addEditDataAPI(endpoint, 'post', DTO)
        toast.success('فیش با موفقیت ثبت شد')
        refreshTable()
        resetForm({})
        setIamgeId('')
        setOpen(false)
      } catch {}
    },
  })

  return (
    <Modal
      visible={open}
      setVisible={setOpen}
      title={title}
      handleClose={() => {
        resetForm({})
        setIamgeId('')
        setOpen(false)
      }}
    >
      <p>
        هاب : <span className=' font-bold'>{currenthub?.label}</span>
      </p>
      <form onSubmit={handleSubmit}>
        <div className='grid2 my-6 w-[35rem] '>
          <InputText
            label='شماره سند'
            name='receiptNo'
            handleChange={handleChange}
            values={values.receiptNo}
            important
            error={touched.receiptNo && errors.receiptNo}
            wrapperClassName='w-full'
          />
          <DatePickers
            WrapperClassName='w-full '
            important
            title='تاریخ '
            values={values.receiptDate}
            name='receiptDate'
            handleChange={setFieldValue}
            error={touched.receiptDate && errors.receiptDate?.day}
          />
          <InputNumber
            label='مبلغ پرداخت شده'
            name='price'
            handleChange={setFieldValue}
            values={values.price}
            important
            error={touched.price && errors.price}
            wrapperClassName='w-full'
            readOnly={!!price}
          />
          {/* <MultiLineText
            label=' توضیحات'
            values={values.description}
            name='description'
            handleChange={handleChange}
            error={touched.description && errors.description}
            wrapperClassName='col-span-2'
          /> */}
        </div>

         <UploadFile onImageUploaded={(imageId)=>setIamgeId(imageId)} />
        <div className='btnForm'>
          <SimpleButton
            handelClick={() =>
              onCancel ? onCancel() : setOpen({ ...open, bankDelivery: false })
            }
            text='انصراف'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            text=' ذخیره'
            className='full-tomato-btn'
            loading={isSubmitting}
          />
        </div>
      </form>
    </Modal>
  )
}

export default BankDelivery
